import { RoleType } from '@enums/role-type.enum';
import { Role } from '@models/role.model';
import { createContext } from 'react';

export interface RolesContextType {
  roles: Role[] | undefined;
  getRoleBasedOnType: (roleType: RoleType) => Role;
  getRoleBasedOnId: (roleId: number) => Role;
}

export const RolesContext = createContext<RolesContextType | undefined>(
  undefined,
);
